
// ROUTES
require('modules/media-directory/routes/media-directory');
require('modules/media-directory/routes/archive-media-directory');

// CONTROLLERS
require('modules/media-directory/controllers/media-directory');
require('modules/media-directory/controllers/list');
require('modules/media-directory/controllers/create');
require('modules/media-directory/controllers/edit');
//
require('modules/media-directory/controllers/archive-media-directory');
require('modules/media-directory/controllers/archive-list');
require('modules/media-directory/controllers/archive-create');
require('modules/media-directory/controllers/archive-edit');

// SERVICES
require('modules/media-directory/services/media-directory');
require('modules/media-directory/services/list');
require('modules/media-directory/services/create');
require('modules/media-directory/services/edit');
require('modules/media-directory/services/delete');


angular.module('unica_media_directory', [

	// ROUTES
	'unica_media_directory.media_directory_routes',
	'unica_media_directory.archive_media_directory_routes',

	// CONTROLLERS
	'unica_media_directory.media_directory_controllers',
	'unica_media_directory.archive_media_directory_controllers',

	// SERVICES
	'unica_media_directory.media_directory_services'

]);